import { render, staticRenderFns } from "./AdvertisementMediaContent.vue?vue&type=template&id=115cbfcf&scoped=true"
import script from "./AdvertisementMediaContent.vue?vue&type=script&lang=js"
export * from "./AdvertisementMediaContent.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementMediaContent.vue?vue&type=style&index=0&id=115cbfcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115cbfcf",
  null
  
)

export default component.exports